module.exports = __webpack_public_path__ + "media/images/flags/hk-99b41311a509aca54f06072e7d7fe662.svg";